// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'copy-solid';

export const Component = () => (
  <path d='M23.605 6.934v14.703a.943.943 0 0 1-.288.67c-.239.24-.479.335-.719.335H6.89a.837.837 0 0 1-.67-.335.946.946 0 0 1-.288-.67v-1.964h11.781c.527 0 1.006-.191 1.39-.575.383-.383.574-.861.574-1.389V5.93h2.921c.24 0 .48.095.72.287.19.239.287.479.287.718Zm-4.933 10.775V3.006c0-.239-.096-.479-.288-.718a.946.946 0 0 0-.67-.288H2.005a.946.946 0 0 0-.67.288c-.239.24-.335.478-.335.718V17.71c0 .24.096.48.335.67.192.24.431.336.67.336h15.71a.839.839 0 0 0 .67-.335.946.946 0 0 0 .287-.67Z' />
);

export const viewBox = '0 0 25 25';
